import React, { useEffect, useState } from 'react';
import { employeeAdminAPI } from '../services/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { History } from 'lucide-react';

const fmt = (v) => (v === null || v === undefined || v === '' ? '—' : String(v));

const EmployeeEditHistory = ({ employeeId, refreshKey }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    employeeAdminAPI.history(employeeId)
      .then(r => setItems(r.data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [employeeId, refreshKey]);

  return (
    <Card data-testid="employee-edit-history">
      <CardHeader><CardTitle className="flex items-center gap-2 text-base"><History size={16} />Change Log</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        {loading ? <p className="text-sm text-muted-foreground">Loading…</p> : items.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="edit-history-empty">No Super Admin edits recorded yet.</p>
        ) : items.map((h) => (
          <div key={h.id} className="border rounded-md p-3" data-testid={`edit-history-item-${h.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-muted-foreground mb-2">
              <span>{new Date(h.created_at).toLocaleString()} · by {h.changed_by_name || h.changed_by_email}</span>
              {h.sessions_revoked && <Badge variant="secondary">Signed out everywhere</Badge>}
            </div>
            <div className="space-y-1 text-sm">
              {Object.entries(h.changes).map(([field, c]) => (
                <div key={field} className="grid grid-cols-1 sm:grid-cols-[160px_1fr] gap-1">
                  <span className="font-medium capitalize">{field.replace(/_/g, ' ')}</span>
                  <span className="break-all"><span className="line-through text-muted-foreground">{fmt(c.from_name || c.from)}</span> → {fmt(c.to_name || c.to)}</span>
                </div>
              ))}
            </div>
            {h.reason && <p className="text-xs mt-2 italic text-muted-foreground">Reason: {h.reason}</p>}
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default EmployeeEditHistory;
